import React from 'react';

function SoloProjectContent() {
  return (
    <>
      <p>Information about the development team behind Repo Prompt.</p>
      <h3>Development Team</h3>
      <p>Yes, Repo Prompt is currently a solo project.</p>
    </>
  );
}

export default SoloProjectContent;